import styled from "styled-components";

import { inputStyles } from "../../../constants/Styles";

const numberInputStyles = `
  width: 100%;
  -moz-appearance: textfield;
  ${inputStyles};

  // Hiding default number toggle as it cannot be styled
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const Input = styled.input`
  ${numberInputStyles};
`;

const InputField = styled.div`
  position: relative;
  -moz-appearance: textfield;
`;

const ToggleArea = styled.div<{ isSmallSize?: boolean }>`
  position: absolute;
  top: 50%;
  right: 0.625rem;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;

  ${({ isSmallSize }) => isSmallSize && `right: 0.5rem;`}
`;

const Toggle = styled.div<{ disabled?: boolean }>`
  width: 0.625rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: brightness(50%);

  ${({ disabled }) =>
    !disabled &&
    `
     cursor: pointer;
       &:hover {
            filter: brightness(100%);
       }
  `}
`;

export { Input, InputField, ToggleArea, Toggle, numberInputStyles };
